// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"a42ebfb8","353":"998365d4"}[chunkId] + ".js";
};